import { makeStyles } from '@material-ui/styles';
import { colors } from '../../../style/colors';
import { ITheme } from '../../../style/theme';

export const useStyles = makeStyles((theme: ITheme) => ({
  tabs: {
    [theme.breakpoints.down('xs')]: {
      maxWidth: '320px',
    },
  },
  filterWrapper: {
    display: 'flex',
    paddingBottom: 24,
    gap: 16,
    flexWrap: 'wrap',
  },
  filtersLabel: {
    paddingTop: 24,
    paddingBottom: 24,
    color: colors.darkestGray,
    fontWeight: 700,
  },
}));
